<script>

export default {
  props: {
    selectedCount: {
      type: Number,
      default: 0
    },
    isShowTitle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      expand: false
    };
  },
  computed: {
    selectedShow() {
      return this.selectedCount > 0;
    }
  },
  watch: {
    selectedShow() {
      if (this.selectedShow) {
        this.expand = false;
      }
    }
  }
}
</script>

<template>
  <div class="table-selection-total-collapse">
    <!-- 已选 -->
    <div
      v-if="selectedShow"
      class="row selected flex justify-between align-end"
      :class="{
        expand: expand
      }"
    >
      <div class="flex align-end">
        <div class="title">
          <span>已选</span>
          <span v-if="selectedCount">(<span class="text-primary text-bold">{{ selectedCount }}</span>)</span>
        </div>
        <div class="flex align-end gap-xsl">
          <slot name="selected"></slot>
        </div>
      </div>
      <collapse-button v-model="expand"></collapse-button>
    </div>
    <!-- 全部 -->
    <div v-if="!selectedShow || (selectedShow && expand)">
      <div class="row flex justify-between align-end">
        <div class="flex align-end">
          <div v-if="isShowTitle" class="title">全部</div>
          <div class="flex align-end gap-xsl">
            <slot name="all"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// * ~ .table-selection-total-collapse {
//   margin-top: 16px;
// }
.table-selection-total-collapse {
  border-radius: 4px;
  background: var(--color-fill-2);
  width: 100%;

  .title {
    width: 100px;
  }

  .row {
    padding: 1em 2em;
    white-space: nowrap;

    &.selected.expand {
      position: relative;
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 1em;
        right: 1em;
        height: 1px;
        background: var(--color-border-2);
      }
    }
  }
}
</style>
